import React from 'react';
import classnames from 'classnames';
import {getBreakLinesTextShumaType3} from "../../../utils/texts";
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';

const Section8Text3 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {registerDetailsNotes} = context.data.pdfData;

  return (
    <div ref={ref}>
      {Boolean(registerDetailsNotes) && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          {getBreakLinesTextShumaType3(registerDetailsNotes)}
        </div>
      )}
    </div>
  );
});

export default Section8Text3;
